// extracted by mini-css-extract-plugin
export default {"content":"source-credit_content__9HlzH","icon":"source-credit_icon__gLVUn"};